import React from 'react';

import { Form as AntForm } from 'antd';

import useClassNames from '~/hooks/use-classnames';

import styles from './Form.module.scss';

const Form = ({
    onSubmit, ...others
}) => {
    return (
        <AntForm
            {...others}
            onSubmitCapture={onSubmit}
        />
    );
};

Form.defaultProps = {
    layout: 'vertical',
};

const FormItem = ({
    className, size, children,
    label, required, labelType, ...others
}) => {
    const classes = useClassNames([
        {
            [styles.formItemLarge]: size === 'large',
            [styles.formItemWithLabel]: label,
        },
        styles.formItem,
        className,
    ]);

    const labelClasses = useClassNames([
        styles.basicLabel,
        { [styles.floatingLabel]: labelType === 'floating' },
    ]);

    const renderLabel = () => {
        if (!label) return null;

        return (
            // eslint-disable-next-line jsx-a11y/label-has-associated-control
            <label className={labelClasses}>
                {label} {required ? <span className={styles.floatingLabelRequired}>*</span> : null}
            </label>
        );
    };

    const renderContent = () => {
        if (labelType === 'floating') {
            return (
                <>
                    {children}
                    {renderLabel()}
                </>
            );
        }

        return (
            <div className={styles.container}>
                {renderLabel()}
                {children}
            </div>
        );
    };

    return (
        <AntForm.Item
            className={classes}
            required={required}
            {...others}
        >
            {renderContent()}
        </AntForm.Item>
    );
};

FormItem.defaultProps = {
    labelType: 'floating',
};

Form.Item = FormItem;

export default Form;
